var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 16.9706 16.9706 21 12 21C10.4576 21 9.00575 20.612 7.73684 19.9282C5.96694 18.9745 4.77596 19.8612 3.72561 20.0202C3.56628 20.0444 3.4076 19.9865 3.29366 19.8726C3.1207 19.6996 3.08778 19.4322 3.18332 19.207C3.59556 18.2354 3.97408 16.3941 3.45797 14.8421C3.16086 13.9487 3 12.9931 3 12C3 7.02943 7.02943 3 12 3C16.9706 3 21 7.02943 21 12Z",
    stroke: "#3469E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6842 15.3142C8.6842 13.4829 10.1687 11.9984 12 11.9984C13.8313 11.9984 15.3158 13.4829 15.3158 15.3142M13.8947 10.1052C13.8947 11.1516 13.0465 11.9999 12 11.9999C10.9535 11.9999 10.1053 11.1516 10.1053 10.1052C10.1053 9.05875 10.9535 8.21045 12 8.21045C13.0465 8.21045 13.8947 9.05875 13.8947 10.1052Z",
    stroke: "#3469E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.b29d01276e4a75567c10da5bb68b691f.svg";
export { ForwardRef as ReactComponent };